<template>
    <div class="page">
        <p>
            {{ date }}
        </p>
        <p>
            {{ userStore.user.firstname }}
            {{ userStore.user.lastname }}
            <br />{{ userStore.user.address }}
            <br />{{ userStore.user.city }},
            {{ userStore.user.state }}
            {{ userStore.user.zipcode }}
            <br />
            <br />
            {{ creditor.creditor_name }}
            <br />
            <template v-if="creditor.address">
                {{ creditor.address }}
            </template>
            <template v-else>
                {{ creditor.address_line }}<br /> {{ creditor.city }}, {{ creditor.state }} {{ creditor.zipcode }}
            </template>
        </p>
        <p>To Whom It May Concern;</p>
        <p class="letter-content">
            The reason for this letter is to dispute an unauthorized inquiry on my credit report.
        </p>
        <p v-for="(inquiry, iteration) in accounts">
            Made by your company {{ inquiry.creditor_name }} on {{ inquiry.date_of_inquiry }}.
            <template v-if="inquiry.reason">
                {{ inquiry.reason }}
            </template>
        </p>
        <p class="letter-content">
            To my knowledge, I have not signed any documents authorizing your organization to view my credit history. Therefore, your inquiry into my credit report violates the Fair Credit Reporting Act, Section 1681b(a): Permissible Purposes of Consumer Reports as well as Section 1681b(c): Transactions Not Initiated by Consumer.
        </p>
        <p class="letter-content">
            If you are in possession of any documentation — bearing my signature — that you believe authorizes you or your organization to make inquiries into my credit report, I respectfully request a copy be sent to my address listed above.
        </p>
        <p class="letter-content">
            For the sake of clarity, I will not accept any documentation that does not bear my signature authorizing you to make an inquiry into my credit file. Otherwise, anyone having stolen my identity could be behind this unauthorized inquiry. And YOU would be in violation of the Fair Credit Reporting Act.
        </p>
        <p style="page-break-after: always;">
            Sincerely,
            <br />
            <br />
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}<br />
        </p>
    </div>
    <div class="page-content">
        <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
        <p style="padding-top:3rem; text-align: center;">
            <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
            <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
        </p>
        <p v-if='userStore.user.address_verify_image_url'>
            <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import { useReportStore } from '../../stores/ReportStore.js'
    import moment from 'moment';
    import lodash from 'lodash'
    export default {
        props: {
            accounts: {
                type: [Array, Object]
            },
            creditor: {
                type: [Array, Object]
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                reportStore: useReportStore(),
                lodash: lodash
            };
        }
    };
</script>